import { render } from "./add-product-modal.vue?vue&type=template&id=4c3ea0b2&scoped=true"
import script from "./add-product-modal.vue?vue&type=script&lang=js"
export * from "./add-product-modal.vue?vue&type=script&lang=js"

import "./add-product-modal.vue?vue&type=style&index=0&id=4c3ea0b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4c3ea0b2"]])

export default __exports__